import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message } from 'antd';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import Spacer from '../../components/Spacer';
import DispatchForm from '../../components/DispatchForm';
import { fetchDispatchTrackingNumber, createDispatch } from '../ducks';

export class DeliveryDispatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trackingNumberValidation: [],
      preventDuplicate: true,
      errorMessage: ' ',
      totalCWT: [],
      trackingNumberRows: [],
      errors: [],
      isSubmitting: false,
    };
    this.packageFormHandler = this.packageFormHandler.bind(this);
    this.formSubmitHandler = this.formSubmitHandler.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
    let atwCacheString = window.localStorage.getItem('del_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    let tnsString = "";
    for(let i = 0; i < atwCache.length; i++){
      let tn = atwCache[i];
      tnsString+=tn+'\n';
    }
    if(tnsString.length > 0){
          this.packageFormHandler({comment:"",tracking_number:tnsString});
    }
  }
removeTnCache(tn){
    let atwCacheString = window.localStorage.getItem('del_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    const index = atwCache.indexOf(tn);

    if (index !== -1) {
        atwCache.splice(index, 1);
        window.localStorage.setItem('del_cache',JSON.stringify(atwCache));
    }
  }
  getTnCacheArray(tn){
    let atwCacheString = window.localStorage.getItem('del_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    return atwCache;
  }
  addTnCache(tn){
    tn = tn.toUpperCase();
    let atwCacheString = window.localStorage.getItem('del_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    if(atwCache.includes(tn)){
      return;
    }
    atwCache.push(tn);
    window.localStorage.setItem('del_cache',JSON.stringify(atwCache));
  }
  deleteHandler(trackingNumber) {
    const { trackingNumberRows, totalCWT } = this.state;
    this.removeTnCache(trackingNumber);
    const filteredTrackingNumber = trackingNumberRows.filter(
      data => data.tracking_number !== trackingNumber,
    );
    const filteredTrackingNumberCWT = totalCWT.filter(
      data => data.id !== trackingNumber,
    );

    this.setState({
      trackingNumberRows: filteredTrackingNumber,
      totalCWT: filteredTrackingNumberCWT,
    });

    message.success('Successfully removed tracking number!');
  }

  packageFormHandler(values) {
    console.log(values);
    const { trackingNumberRows } = this.state;
    const { doFetchDispatchTrackingNumber } = this.props;
    this.setState(prevState => ({
      trackingNumberValidation: [
        ...prevState.trackingNumberValidation,
        { tracking_number: values.tracking_number },
      ],
    }));

    const splitTrackingNumber = values.tracking_number
      ? values.tracking_number.split('\n')
      : '';

    const filteredTrackingNumber = splitTrackingNumber.filter(
      (item, key) => splitTrackingNumber.indexOf(item) >= key && item !== '',
    );

    // eslint-disable-next-line no-unused-vars
    filteredTrackingNumber.forEach((item, key) => {
      this.addTnCache(item);
      const { trackingNumberValidation: validation } = this.state;
      // console.log(validation);
      const existLocal = validation.filter(tn => tn.tracking_number === item);

      const exists = trackingNumberRows.filter(
        tn => tn.tracking_number === item,
      );

      if (existLocal.length > 0) {
        console.log('first console log');
        message.error(`Tracking number ${item} is already entered.`);
        this.setState(prevState => ({
          preventDuplicate: true,
          errorMessage: `Tracking number ${item} is already entered.`,
          errors: [
            ...prevState.errors,
            {
              tracking_number: item,
              message: 'Tracking number is already entered.',
            },
          ],
        }));
      } else if (exists.length > 0) {
        message.error(`Tracking number ${item} is already entered.`);
        this.setState(prevState => ({
          preventDuplicate: true,
          errorMessage: `Tracking number ${item} is already entered.`,
          errors: [
            ...prevState.errors,
            {
              tracking_number: item,
              message: 'Tracking number is already entered.',
            },
          ],
        }));
      } else {
        doFetchDispatchTrackingNumber('delivery', item)
          .then((action) => {
            const cwtTotal = (parseFloat(action.payload.data.length, 10)
                  * parseFloat(action.payload.data.width, 10)
                  * parseFloat(action.payload.data.height, 10))
                / 6500;
            const weightTotal = parseFloat(action.payload.data.weight, 10);
            const totalCWTNumber = cwtTotal < weightTotal ? weightTotal : cwtTotal;
            this.setState(prevState => ({
              trackingNumberValidation: [],
              preventDuplicate: true,
              errorMessage: ' ',
              trackingNumberRows: [
                ...prevState.trackingNumberRows,
                {
                  address_city: action.payload.data.address_city,
                  tracking_number: item,
                  consignee_address: action.payload.data.consignee_address,
                  payment_type: action.payload.data.payment_type,
                  consignee_name: action.payload.data.consignee_name,
                  length: action.payload.data.length,
                  width: action.payload.data.width,
                  height: action.payload.data.height,
                  weight: weightTotal,
                  cwt: cwtTotal,
                },
              ],
              totalCWT: [
                ...prevState.totalCWT,
                { id: item, cwtTotalNum: totalCWTNumber },
              ],
            }));
            message.success(`Successfully added ${item}`);
          })
          .catch((action) => {
            let errorMessage;
            this.removeTnCache(item);
            if (action.error.response.status === 400) {
              errorMessage = action.error.response.data.message;
              this.setState(prevState => ({
                trackingNumberValidation: [],
                preventDuplicate: true,
                errorMessage: action.error.response.data.message,
                errors: [
                  ...prevState.errors,
                  {
                    tracking_number: item,
                    message: action.error.response.data.message,
                  },
                ],
              }));
            } else {
              errorMessage = 'Something went wrong, please try again later.';
            }
            message.error(errorMessage, 3);
          });
      }
    });
  }

  formSubmitHandler(values) {
    const { trackingNumberRows } = this.state;
    const { doCreateDispatch, history } = this.props;
    if (trackingNumberRows.length > 0) {
      const packages = [];

      this.setState({
        isSubmitting: true,
      });
      // eslint-disable-next-line no-unused-vars
      trackingNumberRows.forEach((item, key) => {
        packages.push(item.tracking_number);
      });

      const params = {
        ...values,
        type: 'delivery',
        packages,
      };

      doCreateDispatch(params)
        .then((action) => {
          let ar = [];
          window.localStorage.setItem('del_cache',JSON.stringify(ar));
          this.setState({
            isSubmitting: false,
          });
          history.push(`/delivery/${action.payload.data.dh_id}`);
        })
        .catch(() => {
          this.setState({
            isSubmitting: false,
          });
          message.error('Something went wrong, please try agian later.');
        });
    } else {
      message.error('No tracking number found!');
    }
  }

  render() {
    const {
      trackingNumberRows,
      errors,
      isSubmitting,
      totalCWT,
      errorMessage,
      preventDuplicate,
    } = this.state;

    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Delivery',
      },
      {
        breadcrumbName: 'Dispatch',
      },
    ];

    const listColumns = [
      {
        Header: 'Tracking Number',
        accessor: 'tracking_number',
      },
      {
        Header: 'Customer',
        accessor: 'consignee_name',
      },
      {
        Header: 'City',
        accessor: 'address_city',
      },
      {
        Header: 'Consignee Address',
        accessor: 'consignee_address',
      },
      {
        Header: 'Payment Type',
        accessor: 'payment_type',
      },
      {
        Header: 'Lenght',
        accessor: 'length',
      },
      {
        Header: 'Width',
        accessor: 'width',
      },
      {
        Header: 'Height',
        accessor: 'height',
      },
      {
        Header: 'Weight',
        accessor: 'weight',
      },
      {
        Header: 'CWT',
        Cell: data => (
          <React.Fragment>
            <p>
              {data.original.cwt < data.original.weight
                ? data.original.weight
                : data.original.cwt}
            </p>
          </React.Fragment>
        ),
      },
    ];

    const selectOptions = ['vehicle', 'courier', 'outsource'];

    const requiredFormSubmitFields = [
      'driver_id',
      'driver2_id',
      'helper_id',
      'helper2_id',
      'vehicle_id',
      'remarks',
      'outsource',
      'driver_rate',
      'driver2_rate',
      'helper_rate',
      'helper2_rate',
    ];

    const requiredPackageFormFields = ['tracking_number'];

    return (
      <div className="DeliveryDispatch">
        <PageHeader title="Delivery" routes={breadCrumbs} />
        <Spacer />
        <Container>
          <DispatchForm
            doPreventDuplicate={preventDuplicate}
            formInformation="Delivery Information"
            tablInformation="Delivery Dispatch List"
            selectOptions={selectOptions}
            requiredFormSubmitFields={requiredFormSubmitFields}
            requiredPackageFormFields={requiredPackageFormFields}
            listColumns={listColumns}
            packageFormHandler={this.packageFormHandler}
            formSubmitHandler={this.formSubmitHandler}
            deleteHandler={this.deleteHandler}
            dispatchItems={trackingNumberRows}
            totalPackageWeight={totalCWT}
            errorItems={errors}
            errorMessageDispatch={errorMessage}
            isSubmitting={isSubmitting}
            hasOutsource
          />
        </Container>
      </div>
    );
  }
}

DeliveryDispatch.propTypes = {
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  doFetchDispatchTrackingNumber: PropTypes.func.isRequired,
  doCreateDispatch: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  doFetchDispatchTrackingNumber: fetchDispatchTrackingNumber,
  doCreateDispatch: createDispatch,
};

export default connect(null, mapDispatchToProps)(DeliveryDispatch);
